import { appSettings } from "../AppSettings";
import apiClient from "./ApiClient";

const CUR_VER = 1;

export interface IUserSettings {
    version: number;
    scanner: {
        cameraIndex?: number;
        focus?: number;
        flashOn?: boolean;
    },
    continusMode?: boolean;
    checkOnlyMode?: boolean;
    apiUrl?: string;
    cameraEngine?: "Cognex" | "ZXing" | "ZBar" | string;
    debugMode?: boolean;
    scanDelay?: number;
    logo?: string;
    monitorMode?: boolean;
    offlineMode?: boolean;
    pingTimeout?: number;
    onlineCheckInterval?: number;
    enableScannerBLT?: boolean;
    hideMenu?: boolean;
    invertDisplay?: boolean;
}

class UserSettingsStore {
    protected _current: IUserSettings;

    async loadAsync() {
        const json = localStorage.getItem("Settings");
        if (!json)
            this._current = {
                version: CUR_VER,
                continusMode: false,
                checkOnlyMode: false,
                debugMode: false,
                enableScannerBLT: false,
                monitorMode: false,
                offlineMode: false,
                scanner: {}
            };
        else
            this._current = JSON.parse(json);

        Object.assign(appSettings, this._current);
    }

    async saveAsync() {

        localStorage.setItem("Settings", JSON.stringify(this._current));

        Object.assign(appSettings, this._current);

        apiClient.open(appSettings.apiUrl, appSettings.accessToken);
    }

    get current() {
        return this._current;
    }
}

export const userSettingsStore = new UserSettingsStore();